module.exports = __webpack_public_path__ + "static/media/technical-ico.3b40ab13.svg";